/**
 * Full-viewport loading overlay with backdrop blur and scroll lock.
 */
import { useEffect } from "react";

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {string} [props.message]
 * @param {string} [props.ariaLabel]
 */
export default function LoadingOverlay({ open, message = "", ariaLabel = "Loading" }) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm transition-opacity duration-300"
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label={ariaLabel}
    >
      <div
        className="h-12 w-12 rounded-full border-2 border-white/30 border-t-sky-300 animate-spin"
        aria-hidden
      />
      {message ? (
        <p className="mt-4 max-w-sm px-4 text-center text-sm text-white/90">{message}</p>
      ) : null}
    </div>
  );
}
